import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import OpenMRS from 'images/OpenMRS.png';
import { FormEvent, useState } from 'react';
import langList from 'pages/PatientAdminLogin/languageList.json';
import { useTranslation } from 'react-i18next';
import { StringMap, TOptions } from 'i18next';
import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { useNavigate } from 'react-router-dom';

interface LangList {
  label: string;
  value: string;
}
export type i18translateType = {
  t: (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    options?: string | TOptions<StringMap> | undefined,
  ) => string;
};
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
    border: '1px solid #ced4da',
    fontSize: 16,
    width: 'fullWidth',
    padding: '10px 12px',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));
export default function PatientAdminLogin() {
  const navigate = useNavigate();
  const { t }: i18translateType = useTranslation();
  const [selectedLang, setSelectedLang] = useState(
    ({ label: 'English (Standard)', value: 'en' } as LangList) || null,
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleLangChange = (lang: any) => {
    setSelectedLang(lang);
  };
  const [userName, setUserName] = useState('admin');
  const [emailErrorMsg, setEmailErrorMsg] = useState('');
  const [password, setPassword] = useState('admin');
  const [passwordErrorMsg, setPasswordErrorMsg] = useState('');

  const handleLoginForm = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };
  const login = () => {
    if (userName === '' && password === '') {
      setEmailErrorMsg('usename should not be empty');
      setPasswordErrorMsg('Password should not be em empty');
    } else if (userName !== '' && password === '') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('Password should not be em empty');
    } else if (userName === '' && password !== '') {
      setEmailErrorMsg('usename should not be em empty');
      setPasswordErrorMsg('');
    } else if (userName !== 'admin' && password !== '') {
      setEmailErrorMsg('please use username as: admin');
      setPasswordErrorMsg('');
    } else if (userName !== '' && password !== 'admin') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('Please use password as: admin');
    } else if (userName === 'admin' && password === 'admin') {
      setEmailErrorMsg('');
      setPasswordErrorMsg('');
      navigate('/openmrslogindetails');
    }
  };
  return (
    <Container sx={{ py: 8, maxHeight: '100%' }} maxWidth='sm'>
      <Card>
        <CardContent>
          <Box component='form' onSubmit={handleLoginForm} noValidate>
            <Stack direction='column' justifyContent='flex-start' alignItems='center' spacing={2}>
              <img src={OpenMRS} style={{ maxWidth: '90%' }} />
              <Grid container direction='row' justifyContent='center' alignItems='center'>
                <Grid item>
                  <Typography variant='h5' sx={{ fontWeight: 'bold' }}>
                    {t('laundryLogin', { ns: ['home'] })}
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
              >
                <Grid item>
                  <Typography variant='subtitle1'>
                    {t('patientAdminUserName', { ns: ['home'] })}
                  </Typography>
                </Grid>
                <Grid item>
                  <BootstrapInput
                    defaultValue={userName}
                    id='bootstrap-input'
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                  {emailErrorMsg !== '' ? (
                    <Typography style={{ color: '#d32f2f' }} sx={{ fontSize: 14 }}>
                      {emailErrorMsg}
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
              >
                <Grid item>
                  <Typography variant='subtitle1'>
                    {t('patientAdminPassword', { ns: ['home'] })}
                  </Typography>
                </Grid>
                <Grid item>
                  <BootstrapInput
                    defaultValue={password}
                    id='bootstrap-input'
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {passwordErrorMsg !== '' ? (
                    <Typography style={{ color: '#d32f2f' }} sx={{ fontSize: 13 }}>
                      {passwordErrorMsg}
                    </Typography>
                  ) : null}
                </Grid>
              </Grid>
              <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='flex-start'
              >
                <Grid item>
                  <Typography variant='subtitle1'>
                    {t('patientAdminLanguage', { ns: ['home'] })}
                  </Typography>
                </Grid>
                <Grid item>
                  <Autocomplete
                    value={selectedLang}
                    options={langList}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    onChange={(_event, value: LangList) => handleLangChange(value!)}
                    disableClearable
                    disablePortal
                    id='combo-box-demo'
                    sx={{ width: 238 }}
                    getOptionLabel={(option) => `${option.label}`}
                    renderInput={(params) => <TextField {...params} size='small' sx={{ pl: 2 }} />}
                  />
                </Grid>
              </Grid>
              <Button variant='contained' fullWidth onClick={() => login()}>
                <Typography style={{ textTransform: 'none' }}>
                  {t('patientAdminButton', { ns: ['home'] })}
                </Typography>
              </Button>
              <Grid container direction='row' justifyContent='center' alignItems='center'>
                <Grid item>
                  <Typography variant='subtitle1'>
                    {t('patientAdminFooter', { ns: ['home'] })}
                  </Typography>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </CardContent>
      </Card>
      <Grid container direction='row' justifyContent='flex-start' alignItems='center' pt={8}>
        <Grid item>
          <Typography variant='subtitle1'>{t('login', { ns: ['home'] })}</Typography>
        </Grid>
      </Grid>
    </Container>
  );
}
